export default __webpack_public_path__ + "static/media/dai.a2c311e8.png";